<script>
	import registrationTypes from "../config/registrationTypes";

	import ClaimantIndividual from "./ClaimantIndividual.svelte";
	import ClaimantJointHolder from "./ClaimantJointHolder.svelte";
	import ClaimantPartnership from "./ClaimantPartnership.svelte";
	import ClaimantCompany from "./ClaimantCompany.svelte";
	import ClaimantTrust from "./ClaimantTrust.svelte";
	import ClaimantSMSF from "./ClaimantSMSF.svelte";
	import ClaimantInsto from "./ClaimantInsto.svelte";
	import ClassActionEmailAddress from "./ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "./ClassActionPhoneNumber.svelte";

	export let registrationType;
	export let claimant;
	export let investor;
	export let jointHoldings;
	export let contact;
	export let disabled = null;
	export let required = null;
</script>

{#if registrationType == registrationTypes.types.SomeoneElse.name}
	<ClaimantIndividual
		bind:individual={claimant}
		bind:contact
		bind:capacity={investor.Capacity}
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{:else if registrationType == registrationTypes.types.Joint.name}
	<ClaimantJointHolder
		bind:jointHoldings
		bind:contact
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{:else if registrationType == registrationTypes.types.Partnership.name}
	<ClaimantPartnership
		bind:partnershipName={investor.InvestorEntityName}
		bind:partnershipMembers={investor.Partnership_Members}
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{:else if registrationType == registrationTypes.types.Trust.name}
	<ClaimantTrust
		bind:trustName={investor.InvestorEntityName}
		bind:trustTrustee={investor.Trust_Trustee}
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{:else if registrationType == registrationTypes.types.Company.name}
	<ClaimantCompany
		bind:name={investor.InvestorEntityName}
		bind:acnAbn={investor.Company_ACNABN}
		bind:capacity={investor.Capacity}
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{:else if registrationType == registrationTypes.types.Insto.name}
	<!-- <ClaimantInsto
    bind:name={investor.InvestorEntityName}
    bind:capacity={investor.Capacity}
    bind:employeeRole={investor.Insto_EmployeeRole}
    bind:authorisedToAct={investor.AuthorisedToAct}
    {disabled}
    {required}
  /> -->
	<p>
		Please email <ClassActionEmailAddress /> confirming your intention to register. Please also provide your trading
		data in Nuix shares between 18 November 2020 and the date you complete your registration, any applicable HIN or SRN,
		and any supporting documentation and our team will complete your registration on your behalf and advise if any further
		information is required.
	</p>
{:else if registrationType == registrationTypes.types.SMSF.name}
	<ClaimantSMSF
		bind:name={investor.InvestorEntityName}
		bind:capacity={investor.Capacity}
		bind:authorisedToAct={investor.AuthorisedToAct}
		{disabled}
		{required}
	/>
{/if}
